export const createError = endpoint => dispatch =>
  dispatch({
    type: 'CREATE_ERROR',
    payload: {
      endpoint
    }
  })

export const deleteError = id => dispatch =>
  dispatch({
    type: 'DELETE_ERROR',
    payload: id
  })
